




















































import { Prop, Watch } from "vue-property-decorator";
import Component, { mixins } from "vue-class-component";
import PdfReport from "@/shared/pdfReport";
import MobileMixin from "@/mixins/mobileMixin";
import pdf from "vue-pdf";
import ErrorMixin from "@/mixins/errorMixins";

declare let cordova: any;

@Component({
  components: {
    pdf,
  },
})
export default class PdfViewer extends mixins(MobileMixin, ErrorMixin) {
  public showPdf = false;
  @Prop({ default: false }) public show!: boolean;
  @Prop({ default: true }) public closable!: boolean;
  @Prop() public blob!: any;
  @Prop() public pdfReport!: PdfReport;

  public page: number = 1;
  public numPages: number = 0;
  public errors: string[] = [];
  public scale: number = 1;
  public pdfData: any = "";
  public otherdata: any = "";

  public close() {
    this.showPdf = false;
    this.$emit("input", false);
  }

  public onError(event: any) {
    // console.log("@ERROR", event);
    // console.log(event.path[8].captureEvents);
    this.setErrorFromTxt(this.$t(event).toString());
  }

  // public onLoad(event: any) {}
  public mounted() {
    this.genererPdf();
  }

  public formattedZoom() {
    return (this.scale * 100).toFixed(0);
  }

  public printMe() {
    console.log(this.$refs.myPdfComponent);
    // if(this.$refs.myPdfComponent[0])
    // this.$refs.myPdfComponent[0].print();
  }

  public getZoom() {
    return `width:${this.scale * 100}%`;
  }
  /**
   * methode de transformaton du blob en pdf a afficher
   */
  public genererPdf() {
    // console.log("url rapport", this.blob);
    this.showPdf = true;
    if (this.loading) {
      this.$store.dispatch("login/setLoading", false);
    }
    // console.log(pdfvuer);
    this.pdfData = pdf.createLoadingTask(this.blob);
    // si je supprime cette ligne ca ne fonctionne plus...
    // pdf.createLoadingTask(this.blob);
    // console.log(this.pdfData);
    this.pdfData.promise.then(
      (mypdf: any) => {
        // console.log("*******PDF**********");
        // console.log(mypdf);
        if (mypdf) {
          this.numPages = mypdf.numPages;
        } else {
          this.numPages = 1;
        }
        this.showPdf = true;
      },
      (error: any) => console.log(error)
    );
  }
  /**
   * methode permettant d'enregistrer le pdf
   */
  public async savePdf() {
    // console.log("hello", this.pdfReport);
    this.$store.dispatch("login/setLoading", true);
    const titre = this.pdfReport.titre;

    if (this.isMobile()) {
      const bloburl = this.blob;
      const destination = this.isiOS() ? cordova.file.documentsDirectory : cordova.file.externalDataDirectory;

      window.resolveLocalFileSystemURL(destination, (dir: any) => {
        dir.getFile("downloadedFile.pdf", { create: true }, (file: any) => {
          file.createWriter((fileWriter: any) => {
            fileWriter.write(encodeURI(bloburl));
            fileWriter.onwriteend = () => {
              console.log("Download complete: " + file.toURL());
            };
            fileWriter.onerror = (error: any) => {
              console.log("Error writing file: " + error.toString());
            };
          });
        });
      });

      // Convert the blob URL to a Blob object
      await fetch(bloburl)
        .then((response) => response.blob())
        .then((data) => {
          // Create a FileReader to read the Blob data
          const reader = new FileReader();
          reader.onloadend = () => {
            // Get the Blob as a data URL
            const dataUrl = reader.result;

            // Share the file via the iOS Share Sheet
            window.plugins.socialsharing.share(
              null, // Message
              null, // Subject (optional)
              dataUrl, // File data
              null, // URL (optional)
              () => {
                console.log("File shared successfully");
              },
              (error: any) => {
                console.error("Error sharing file: " + error);
              }
            );
          };
          // Read the Blob data as a data URL
          reader.readAsDataURL(data);
          this.setSuccess("Rapport téléchargé");
        })
        .catch((error) => {
          console.error("Error downloading Blob: " + error);
        });
    } else {
      const fileLink = document.createElement("a");
      fileLink.href = this.pdfReport.src;
      fileLink.setAttribute("download", titre);
      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);
    }
    this.close();
    this.$store.dispatch("login/setLoading", false);
  }

  @Watch("page", { immediate: false })
  public onPropertyChanged(value: number, oldValue: number) {
    // console.log(value, oldValue);
    if (
      window.pageYOffset <= this.findPos(document.getElementById(value + "")) ||
      (document.getElementById(value + 1 + "") &&
        window.pageYOffset >=
          this.findPos(document.getElementById(value + 1 + "")))
    ) {
      const elem = document.getElementById(value + "");
      if (elem !== null) {
        elem.scrollIntoView();
      }
    }
  }

  public changePage() {
    let i = 1;
    const count = Number(this.pdfData.numPages);
    do {
      if (
        window.pageYOffset >= this.findPos(document.getElementById(i + "")) &&
        window.pageYOffset <= this.findPos(document.getElementById(i + 1 + " "))
      ) {
        this.page = i;
      }
      i++;
    } while (i < count);
    if (window.pageYOffset >= this.findPos(document.getElementById(i + ""))) {
      this.page = i;
    }
  }

  private findPos(obj: any) {
    return obj.offsetTop;
  }

  get loading(): boolean {
    return this.$store.getters["login/loading"];
  }
}
